import { render, staticRenderFns } from "./Proctor.vue?vue&type=template&id=118a5ef3&scoped=true&"
import script from "./Proctor.vue?vue&type=script&lang=js&"
export * from "./Proctor.vue?vue&type=script&lang=js&"
import style0 from "./Proctor.vue?vue&type=style&index=0&id=118a5ef3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a5ef3",
  null
  
)

export default component.exports